<template>
 
    <v-container    class="site-footer ma-0">
      <v-divider class="mb-5"></v-divider>
      <v-row>
        <v-col cols="12" md="7"
          ><div
            class="d-flex flex-wrap justify-md-start justify-center justify-md-none"
          >
            <template v-for="(s, i) in menu">
              <a
              :key="i"
                target="_blanck"
                class="text--secondary pa-1 pa-md-0"
                :href="s.link"
                :title="s.seoTitle"
                v-text="s.text"
              />

              <v-responsive
                v-if="i < menu.length - 1"
                :key="`divider-${i}`"
                target="_blanck"
                class="mx-4 shrink hidden-sm-and-down"
                max-height="18"
              >
                <v-divider vertical />
              </v-responsive>
            </template></div
        ></v-col>
        <v-col class="text--secondary text-center text-md-right">
          {{ new Date().getFullYear() }} © copyright - powered by
           <a
            target="_blanck"
            class="pa-1 pa-md-0"
            color="primary"
            href="https://Quickdeliverysystem.com"
            title="Quickdeliverysystem"
            v-text="'Quickdeliverysystem'"
          /> and 
          <a
            target="_blanck"
            class="pa-1 pa-md-0"
            color="primary"
            href="https://pexcode.com"
            title="pexcode | We create stunning digital experiences"
            v-text="'pexcode'"
          />
        </v-col>
      </v-row>
    </v-container> 
</template>

<script>
export default {
  data() {
    return {
      menu: [
      {
          seoTitle: 'Terms conditions  quick delivery system',
          text: 'Terms conditions',
          link: 'https://quickdeliverysystem.com/terms-conditions/index.html',
        },
        {
          seoTitle: 'Privacy policy quick delivery system',
          text: 'Privacy policy',
          link: 'https://quickdeliverysystem.com/privacy/index.html',
        },
        {
          seoTitle: 'Cookies  quick delivery system',
          text: 'Cookies',
          link: 'https://quickdeliverysystem.com/cookie/index.html',
        },
      ],
    }
  },
}
</script>

<style>
.site-footer a {
  text-decoration: none;
}
</style>
